import { render, staticRenderFns } from "./orderPic.vue?vue&type=template&id=3e621fbc&scoped=true"
import script from "./orderPic.vue?vue&type=script&lang=js"
export * from "./orderPic.vue?vue&type=script&lang=js"
import style0 from "./orderPic.vue?vue&type=style&index=0&id=3e621fbc&prod&lang=scss&scoped=true"
import style1 from "./orderPic.vue?vue&type=style&index=1&id=3e621fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e621fbc",
  null
  
)

export default component.exports